export default "__VITE_ASSET__y46Ozjb3__"